import * as React from 'react';
import { Card, Button } from '@comps';
import { Form, Space, Input } from 'antd';
import { Http, Lang } from '@utils';

export interface Props extends React.Props<HTMLElement>,
  React.BaseHTMLAttributes<HTMLElement> {
  onConfirm: () => void,
  onClose: () => void,
};

const BatchDelete: React.FC<Props> = ({ onClose, onConfirm }: Props) => {
  const [form] = Form.useForm();

  const handleConfirm = React.useCallback(() => Lang.noError(async () => {
    await form.validateFields();
    const formData = form.getFieldsValue();
    await Http.del(`/tax/orders/batchDelete`, {
      batchNo: formData.batchNo,
    });
    onConfirm();
  }), [form, onConfirm]);

  return (<Card title='请输入批次号' style={{ marginBottom: '0' }}>
    <Form form={form} labelCol={{ span: 6 }}
      style={{ padding: '30px 60px' }}>
      <Form.Item label="批次号"
        name="batchNo"
        rules={[{ required: true, message: '请输入批次号' }]}>
        <Input />
      </Form.Item>
      <Form.Item wrapperCol={{ offset: 6 }}>
        <Space>
          <Button type="primary"
            clickCallback={handleConfirm}>确认删除</Button>
          <Button onClick={() => onClose()}>取消</Button>
        </Space>
      </Form.Item>
    </Form>
  </Card>);
};

export default BatchDelete;
